var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "session-bg" },
    [
      _c(
        "v-container",
        [
          _c(
            "v-snackbar",
            {
              attrs: { color: _vm.snackbarColor, timeout: "3000", top: "" },
              model: {
                value: _vm.snackbarVisible,
                callback: function ($$v) {
                  _vm.snackbarVisible = $$v
                },
                expression: "snackbarVisible",
              },
            },
            [_vm._v(" " + _vm._s(_vm.snackbarMessage) + " ")]
          ),
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "popup-card" },
                    [
                      _c("v-card-title", { staticClass: "popup-title" }, [
                        _vm._v("Cambiar Contraseña"),
                      ]),
                      _c("v-card-text", [
                        !_vm.passwordUpdated
                          ? _c(
                              "div",
                              [
                                _c(
                                  "v-form",
                                  {
                                    ref: "form",
                                    model: {
                                      value: _vm.formValid,
                                      callback: function ($$v) {
                                        _vm.formValid = $$v
                                      },
                                      expression: "formValid",
                                    },
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Código de seguridad",
                                        rules: [_vm.rules.required],
                                        "prepend-icon": "mdi-key",
                                        clearable: "",
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.token,
                                        callback: function ($$v) {
                                          _vm.token = $$v
                                        },
                                        expression: "token",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Correo electrónico",
                                        type: "email",
                                        rules: [
                                          _vm.rules.required,
                                          _vm.rules.email,
                                        ],
                                        "prepend-icon": "mdi-email",
                                        clearable: "",
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.email,
                                        callback: function ($$v) {
                                          _vm.email = $$v
                                        },
                                        expression: "email",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Contraseña nueva",
                                        type: _vm.showNewPassword
                                          ? "text"
                                          : "password",
                                        "append-icon": _vm.showNewPassword
                                          ? "mdi-eye-off"
                                          : "mdi-eye",
                                        rules: [
                                          _vm.rules.required,
                                          _vm.rules.minLength(8),
                                        ],
                                        "prepend-icon": "mdi-lock",
                                        clearable: "",
                                        outlined: "",
                                        "error-messages": "",
                                      },
                                      on: {
                                        "click:append":
                                          _vm.toggleNewPasswordVisibility,
                                      },
                                      model: {
                                        value: _vm.newPassword,
                                        callback: function ($$v) {
                                          _vm.newPassword = $$v
                                        },
                                        expression: "newPassword",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Confirmar contraseña nueva",
                                        type: _vm.showConfirmPassword
                                          ? "text"
                                          : "password",
                                        "append-icon": _vm.showConfirmPassword
                                          ? "mdi-eye-off"
                                          : "mdi-eye",
                                        rules: [
                                          _vm.rules.required,
                                          () =>
                                            _vm.confirmPassword ===
                                              _vm.newPassword ||
                                            "Las contraseñas no coinciden",
                                        ],
                                        "prepend-icon": "mdi-lock-check",
                                        clearable: "",
                                        outlined: "",
                                      },
                                      on: {
                                        "click:append":
                                          _vm.toggleConfirmPasswordVisibility,
                                      },
                                      model: {
                                        value: _vm.confirmPassword,
                                        callback: function ($$v) {
                                          _vm.confirmPassword = $$v
                                        },
                                        expression: "confirmPassword",
                                      },
                                    }),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "white--text",
                                        attrs: { color: "red", block: "" },
                                        on: { click: _vm.validateForm },
                                      },
                                      [_vm._v(" Guardar ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("p", [
                                  _vm._v(
                                    " La contraseña se ha cambiado exitosamente. Por favor vuelva a la página principal. "
                                  ),
                                ]),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "white--text",
                                    attrs: { color: "red" },
                                    on: { click: _vm.goToLogin },
                                  },
                                  [_vm._v(" Volver al inicio ")]
                                ),
                              ],
                              1
                            ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }